'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _intersection = require('./intersection');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // eslint-disable-line no-unused-vars


var isFunction = function isFunction(func) {
  return typeof func === 'function';
};

/**
 * Monitors scroll, and triggers the children function with updated props
 *
 <Observer>
 {inView => (
   <h1>{`${inView}`}</h1>
 )}
 </Observer>
 */

var Observer = function (_Component) {
  _inherits(Observer, _Component);

  function Observer() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Observer);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Observer.__proto__ || Object.getPrototypeOf(Observer)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      inView: false
    }, _this.node = null, _this.handleNode = function (node) {
      if (_this.node) (0, _intersection.unobserve)(_this.node);
      _this.node = node;
      _this.observeNode();
    }, _this.handleChange = function (inView) {
      return _this.setState({ inView: inView });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Observer, [{
    key: 'componentWillUpdate',
    value: function componentWillUpdate(nextProps, nextState) {
      if (!!this.props.onChange && nextState !== this.state) {
        this.props.onChange(nextState.inView);
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      // If a IntersectionObserver option changed, reinit the observer
      if (prevProps.rootMargin !== this.props.rootMargin || prevProps.root !== this.props.root || prevProps.threshold !== this.props.threshold) {
        (0, _intersection.unobserve)(this.node);
        this.observeNode();
      }

      if (prevState.inView !== this.state.inView) {
        if (this.state.inView && this.props.triggerOnce) {
          (0, _intersection.unobserve)(this.node);
          this.node = null;
        }
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.node) {
        (0, _intersection.unobserve)(this.node);
        this.node = null;
      }
    }
  }, {
    key: 'observeNode',
    value: function observeNode() {
      if (!this.node) return;
      var _props = this.props,
          threshold = _props.threshold,
          root = _props.root,
          rootMargin = _props.rootMargin,
          rootId = _props.rootId;

      (0, _intersection.observe)(this.node, this.handleChange, {
        threshold: threshold,
        root: root,
        rootMargin: rootMargin
      }, rootId);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          children = _props2.children,
          render = _props2.render,
          tag = _props2.tag,
          triggerOnce = _props2.triggerOnce,
          threshold = _props2.threshold,
          root = _props2.root,
          rootId = _props2.rootId,
          rootMargin = _props2.rootMargin,
          props = _objectWithoutProperties(_props2, ['children', 'render', 'tag', 'triggerOnce', 'threshold', 'root', 'rootId', 'rootMargin']);

      var inView = this.state.inView;


      return (0, _react.createElement)(tag, _extends({}, props, {
        ref: this.handleNode
      }),
      // If render is a function, use it to render content when in view
      inView && isFunction(render) ? render() : null,
      // If children is a function, render it with the current inView status.
      // Otherwise always render children. Assume onChange is being used outside, to control the the state of children.
      isFunction(children) ? children(inView) : children);
    }
  }]);

  return Observer;
}(_react.Component);

Observer.propTypes = {
  /** Element tag to use for the wrapping */
  tag: _propTypes2.default.node,
  /** Children should be either a function or a node */
  children: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.node]),
  /** Only trigger the inView callback once */
  triggerOnce: _propTypes2.default.bool,
  /** Number between 0 and 1 indicating the the percentage that should be visible before triggering. Can also be an array of numbers, to create multiple trigger points. */
  threshold: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.number), _propTypes2.default.number]),
  /** The HTMLElement that is used as the viewport for checking visibility of the target. Defaults to the browser viewport if not specified or if null.*/
  root: _propTypes2.default.object,
  /** Margin around the root. Can have values similar to the CSS margin property, e.g. "10px 20px 30px 40px" (top, right, bottom, left). */
  rootMargin: _propTypes2.default.string,
  /** Unique identifier for the root element - This is used to identify the IntersectionObserver instance, so it can be reused.
   * If you defined a root element, without adding an id, it will create a new instance for all components. */
  rootId: _propTypes2.default.string,
  /** Call this function whenever the in view state changes */
  onChange: _propTypes2.default.func,
  /** Use render method to only render content when inView */
  render: _propTypes2.default.func
};
Observer.defaultProps = {
  tag: 'div',
  threshold: 0,
  triggerOnce: false
};
exports.default = Observer;


//////////////////
// WEBPACK FOOTER
// ./~/react-intersection-observer/es/index.js
// module id = 1220
// module chunks = 14